"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./MonthlyCharges.scss");
var components_1 = require("@idp/duc/components");
var CartConfiguration_scss_1 = require("../../../CartConfigurationContainer/CartConfiguration.scss");
var utils_1 = require("@idp/ui-components/utils");
var ui_components_1 = require("@idp/ui-components");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var CartCommon_scss_1 = require("../../../../styles/CartCommon.scss");
var UtilityFunctions_1 = require("../../../../utils/UtilityFunctions");
var MonthlyCharges = /** @class */ (function (_super) {
    __extends(MonthlyCharges, _super);
    function MonthlyCharges(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isModalOpen: false,
        };
        _this.showLink = _this.showLink.bind(_this);
        _this.showModal = _this.showModal.bind(_this);
        _this.monthlyChargesContent = _this.monthlyChargesContent.bind(_this);
        _this.showLineContent = _this.showLineContent.bind(_this);
        _this.initializeEvents = _this.initializeEvents.bind(_this);
        _this.getTaxDetails = _this.getTaxDetails.bind(_this);
        _this.getLosgsData = _this.getLosgsData.bind(_this);
        _this.getPrintGroupText = _this.getPrintGroupText.bind(_this);
        return _this;
    }
    MonthlyCharges.prototype.initializeEvents = function () {
        this.accordianEvents = {
            onToggleCollapse: function () { console.log(' closed '); },
            onToggleOpen: function () { console.log(' open'); },
        };
    };
    MonthlyCharges.prototype.render = function () {
        this.cmsContent = this.props.data && this.props.data.wlsCmsContent;
        return (React.createElement(React.Fragment, null,
            this.showLink(),
            this.state.isModalOpen && this.monthlyChargesContent()));
    };
    MonthlyCharges.prototype.showLink = function () {
        var _this = this;
        return (React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Cart', 'Link', 'Cost_Breakdown'), className: CartCommon_scss_1.commonLinkSmall, 
            // tslint:disable-next-line: jsx-no-lambda
            onClick: function () {
                _this.showModal(true);
            } }, this.props.data.linkText));
    };
    MonthlyCharges.prototype.showModal = function (openModal) {
        this.setState({ isModalOpen: openModal });
    };
    MonthlyCharges.prototype.monthlyChargesContent = function () {
        var _this = this;
        var _a, _b, _c;
        return (React.createElement(ui_components_1.Modal, { testId: "Modal_Monthly_Charges_Details", options: { className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn }, show: this.state.isModalOpen,
                showClose: true,
                size: ModalProps_1.ModalSizes.MEDIUM }, events: { onClose: function () { _this.showModal(false); } }, accessibilityText: "Monthly surcharges, fees, and taxes" },
            React.createElement("div", { className: styles.modalSpacing },
                React.createElement("div", { className: styles.modalTitle },
                    React.createElement("span", null, (_a = this.cmsContent) === null || _a === void 0 ? void 0 : _a.monthlyChargesModalTitle)),
                React.createElement("div", { className: styles.subtitleText }, (_b = this.cmsContent) === null || _b === void 0 ? void 0 : _b.monthlyChargesModalSubTitle),
                React.createElement("div", { className: styles.lineTaxContainer }, this.getLosgsData()),
                React.createElement("div", { className: [CartCommon_scss_1.commonContentSmall, styles.footerContainer].join(' ') },
                    React.createElement("div", { className: styles.solidLightGray }),
                    React.createElement("div", { className: styles.footerContent }, (_c = this.cmsContent) === null || _c === void 0 ? void 0 : _c.monthlyChargesModalFooterLabel)))));
    };
    MonthlyCharges.prototype.getLosgsData = function () {
        var _this = this;
        if (this.props.data && this.props.data.losgs) {
            var losgObje = this.props.data.losgs.map(function (losg, index) {
                return (React.createElement("div", { key: losg.id, className: styles.lineItemContainer }, _this.showLineContent(losg)));
            });
            return losgObje;
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    MonthlyCharges.prototype.showLineContent = function (losg) {
        var _this = this;
        if (losg && losg.losgTaxInfo) {
            var losgTaxInfo = losg && losg.losgTaxInfo;
            var taxData = losgTaxInfo.taxData;
            var optionData_1 = {
                className: {
                    accordionContentClasses: styles.accordionContent,
                    subTitleClasses: styles.taxPrintGroup,
                    titleClasses: styles.taxPrintGroup,
                },
                panelColor: 'white',
            };
            var isOpen_1 = !!(this.props.data.losgsId && (this.props.data.losgsId === losg.id));
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.lineName }, losgTaxInfo.lineName),
                taxData.map(function (data, index) {
                    var keyId = losg.id + "_" + data.printGroup;
                    return (React.createElement("section", { key: keyId, className: styles.accordionContainer },
                        React.createElement(ui_components_1.Accordion, { key: keyId + "_" + index, data: {
                                setOpen: isOpen_1,
                                setSelectionCompleted: true,
                                // tslint:disable-next-line: no-any
                                title: _this.getPrintGroupText(data.printGroup, data.totalTaxAmount),
                            }, events: _this.accordianEvents, options: optionData_1 }, _this.getTaxDetails(data.taxDetails, losg.id))));
                })));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    MonthlyCharges.prototype.getTaxDetails = function (taxDetails, losgId) {
        var taxDetailsList = taxDetails.map(function (taxInfo, index) {
            var keyId = losgId + "_" + taxInfo.printName;
            return (React.createElement("div", { key: keyId, className: styles.taxLineItem },
                React.createElement("div", { className: styles.taxLineContent },
                    React.createElement(ui_components_1.RichText, { testId: utils_1.default('Monthly_Tax', 'content'), data: { isDecodingRequired: false, text: taxInfo.printName } })),
                React.createElement("div", { className: styles.taxLinePrice },
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('Monthly_Tax', "lineItem_price}"), data: { price: taxInfo.taxAmount }, options: {
                            decimalPoints: 2,
                            type: PriceContainerProps_1.PricingType.XSMALL,
                        } }))));
        });
        return taxDetailsList;
    };
    MonthlyCharges.prototype.getPrintGroupText = function (printGroup, totalTaxAmount) {
        var _a, _b;
        var printGroupText = '';
        var elements = [];
        var printGroupType = printGroup && printGroup.toUpperCase() || '';
        switch (printGroupType) {
            case 'SURCHARGENFEE':
                printGroupText = ((_a = this.cmsContent) === null || _a === void 0 ? void 0 : _a.monthlyChargesSurchargesLabel) || 'Surcharges & fees';
                break;
            case 'TAX':
                printGroupText = ((_b = this.cmsContent) === null || _b === void 0 ? void 0 : _b.monthlyChargesTaxesLabel) || 'Government taxes & fees';
                break;
            default:
                printGroupText = '';
        }
        elements.push(React.createElement("div", { className: styles.displayFlex },
            React.createElement("div", null, printGroupText),
            React.createElement("div", null, UtilityFunctions_1.amountWithDecimal(totalTaxAmount, 2, '$'))));
        return elements;
    };
    return MonthlyCharges;
}(React.Component));
exports.default = MonthlyCharges;
//# sourceMappingURL=MonthlyCharges.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CommonCart/common/MonthlyCharges/MonthlyCharges.js
// module id = 2308
// module chunks = 8